import { render } from "./ReceiverIcons.vue?vue&type=template&id=4189a862&scoped=true"
import script from "./ReceiverIcons.vue?vue&type=script&lang=js"
export * from "./ReceiverIcons.vue?vue&type=script&lang=js"

import "./ReceiverIcons.vue?vue&type=style&index=0&id=4189a862&scoped=true&lang=scss"

import exportComponent from "../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4189a862"]])

export default __exports__